<template>
  <div class="min-h-screen px-6 py-8 md:px-10">
    <div class="w-full space-y-6">
      <div class="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <h1 class="mt-2 text-3xl text-gray-900">Avaliações</h1>
          <p class="mt-2 max-w-2xl text-sm text-gray-500">
            Consulte as avaliações recebidas pelo operador.
          </p>
        </div>

        <div class="rounded-2xl border border-gray-200 bg-white px-6 py-4 shadow-sm">
          <p class="text-sm font-medium text-gray-500">Nota Média</p>
          <p class="mt-1 text-2xl font-semibold text-gray-900">
            {{ parseFloat(media || 0).toFixed(1) }}
          </p>
        </div>
      </div>

      <div
        class="w-full overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm"
      >
        <div class="overflow-x-auto">
          <table class="w-full min-w-max text-sm">
            <thead class="border-b bg-gray-100 tracking-wider text-gray-600">
              <tr>
                <th class="px-6 py-4 text-left font-medium">Cliente</th>
                <th class="px-6 py-4 text-left font-medium">Estrelas</th>
                <th class="px-6 py-4 text-left font-medium">Observações</th>
                <th class="px-6 py-4 text-left font-medium">Data Envio</th>
                <th class="px-6 py-4 text-left font-medium">Data Resposta</th>
              </tr>
            </thead>

            <tbody>
              <tr
                v-for="item in list"
                :key="item._id"
                class="border-b border-gray-100 transition hover:bg-slate-50"
              >
                <td class="px-6 py-5">
                  <div class="flex items-center gap-4">
                    <div
                      class="flex h-11 w-11 items-center justify-center rounded-2xl bg-blue-50 text-sm font-semibold text-blue-700"
                    >
                      {{ getClienteNome(item).slice(0, 2).toUpperCase() }}
                    </div>

                    <div class="flex flex-col">
                      <span class="font-medium text-gray-800">
                        {{ getClienteNome(item) }}
                      </span>
                      <span class="text-xs text-gray-400"> Cliente avaliado </span>
                    </div>
                  </div>
                </td>

                <td class="px-6 py-5">
                  <star-rating
                    v-if="item.nota"
                    v-model="item.nota"
                    read-only
                    :star-size="26"
                    :show-rating="false"
                  />

                  <span
                    v-else
                    class="rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-500"
                  >
                    Sem resposta
                  </span>
                </td>

                <td class="max-w-md px-6 py-5 text-gray-700">
                  {{ item.obs || "-" }}
                </td>

                <td class="px-6 py-5 font-medium text-gray-700">
                  <span v-if="item.data">
                    {{ item.data | moment("DD/MM/YYYY HH:mm") }}
                  </span>
                  <span v-else class="text-gray-400">-</span>
                </td>

                <td class="px-6 py-5 font-medium text-gray-700">
                  <span v-if="item.dataResposta">
                    {{ item.dataResposta | moment("DD/MM/YYYY HH:mm") }}
                  </span>
                  <span v-else class="text-gray-400">-</span>
                </td>
              </tr>

              <tr v-if="list.length === 0">
                <td colspan="5" class="px-6 py-12 text-center text-sm text-gray-400">
                  Nenhuma avaliação encontrada.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StarRating from "vue-star-rating";

export default {
  components: {
    StarRating,
  },

  data() {
    return {
      list: [],
      total: 0,
      media: 0,
    };
  },

  methods: {
    getClienteNome(item) {
      return item.chat && item.chat.contato && item.chat.contato.nome
        ? item.chat.contato.nome
        : item.chat && item.chat.contato && item.chat.contato.telefone
        ? item.chat.contato.telefone
        : "-";
    },

    async start() {
      const operadoresReq = await this.$http.post("/v1/operador/avaliacao/list", {
        operador: this.$route.params.id
          ? this.$route.params.id
          : this.$store.state.user._id,
      });

      this.list = operadoresReq.data.data || [];
      this.total = operadoresReq.data.total || 0;
      this.media = operadoresReq.data.media || 0;
    },
  },

  async beforeMount() {
    await this.start();
  },
};
</script>
